import React from 'react';
import { CheckIcon } from 'lucide-react';
import { audienceItems } from '../data/site';
import { SectionCta } from './SectionCta';
export function AudienceSection() {
  return <section className="w-full bg-cream px-5 py-14 sm:px-6 sm:py-20" data-id="element-16" data-mp="s0l2p9f0xx1k">
      <div className="mx-auto max-w-3xl" data-id="element-17" data-mp="s1e6c1ios6fh">
        <h2 className="font-serif text-[28px] font-bold leading-[1.12] text-navy sm:text-4xl" data-id="element-18" data-mp="x07j1rq5ftel">
          Who is this for?
        </h2>
        <p className="mt-4 text-[16px] leading-relaxed text-navy/75 sm:text-[17px]" data-id="element-19" data-mp="3vimluepxyu71">
          Menopause Decision Desk™ is designed for healthcare professionals who evaluate and manage
          patients experiencing perimenopause and menopause. Particularly useful for professionals who:
        </p>

        <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-20" data-mp="e2ee6jvyt9ek">
          {audienceItems.map(item => <li key={item} className="flex items-start gap-2.5 rounded-xl border border-navy/10 bg-white px-4 py-3" data-id="element-21" data-mp="3cqah5lbtfgtq">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-22" data-mp="3hntw6ngc7xmq" />
              <span className="text-[14px] leading-snug text-navy/80" data-id="element-23" data-mp="14a0zv9f8ssdc">{item}</span>
            </li>)}
        </ul>

        <div className="mt-12" data-id="element-24" data-mp="ukzndt7wot44">
          <h2 className="font-serif text-[28px] font-bold leading-[1.12] text-navy sm:text-4xl" data-id="element-25" data-mp="uk7pucur0lb7">
            What makes this different?
          </h2>
          <p className="mt-4 text-[16px] leading-relaxed text-navy/75 sm:text-[17px]" data-id="element-26" data-mp="qhbf18bg9tht">
            Most clinical resources are built around information. Menopause Decision Desk™ is built around
            decisions.
          </p>
          <div className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-27" data-mp="blvk7131ptkd">
            <div className="rounded-xl bg-sand px-4 py-4" data-id="element-28" data-mp="bo7vwwi7n7oz">
              <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-navy/50" data-id="element-29" data-mp="7llc9ivp0t2v">Instead of asking</p>
              <p className="mt-2 font-serif text-[17px] font-semibold italic leading-snug text-navy/70" data-id="element-30" data-mp="25yv4h7idfbxz">
                “What does the guideline say?”
              </p>
            </div>
            <div className="rounded-xl bg-navy px-4 py-4" data-id="element-31" data-mp="3vg8r4g47705j">
              <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-gold-light" data-id="element-32" data-mp="42m8h172his5">You start with</p>
              <p className="mt-2 font-serif text-[17px] font-semibold italic leading-snug text-cream" data-id="element-33" data-mp="3mgvcza54pneh">
                “What decision am I trying to make?”
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 rounded-2xl border border-navy/10 bg-white p-5 sm:p-8" data-id="element-34" data-mp="i25b5eh401x2">
          <h3 className="font-serif text-[22px] font-bold leading-tight text-navy sm:text-[26px]" data-id="element-35" data-mp="n204doocx3la">
            Designed for real consultations
          </h3>
          <p className="mt-3 text-[15px] leading-relaxed text-navy/70" data-id="element-36" data-mp="93teaupng7w6">
            You don’t need another resource that looks impressive but stays inside your downloads folder.
            Menopause Decision Desk™ was designed around practical use:
          </p>
          <div className="mt-5 grid grid-cols-2 gap-2.5 sm:grid-cols-4" data-id="element-37" data-mp="2yrsp3kjwiybj">
            {['Find it.', 'Review it.', 'Apply your judgment.', 'Move forward.'].map(step => <p key={step} className="rounded-xl bg-sand px-3 py-3.5 text-center text-[13px] font-bold uppercase leading-snug tracking-[0.06em] text-navy" data-id="element-38" data-mp="2m8yhjj41uvat">
                {step}
              </p>)}
          </div>
        </div>

        <SectionCta headline="Built for the way you actually work between patients." label="Get access today · $27" data-id="element-39" data-mp="27j9aj799zx2m" />
      </div>
    </section>;
}